module.exports = __webpack_public_path__ + "img/ctrl-aggregate-stub-up--.375f1370.svg";